const AUTH_BASE_URL = 'https://auth.parapetstudios.com/api/Users/';
export const AUTH_TICKET_URL = `${AUTH_BASE_URL}AuthTicket`;
export const AUTH_RENEW_URL = `${AUTH_BASE_URL}Auth`;
export const PASSWORD_URL = `${AUTH_BASE_URL}Password`;
export const PASSWORD_RESET_URL = `${AUTH_BASE_URL}PasswordReset`;
